import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

// Connects to data-controller="laboratorio"
export default class extends Controller {
  static targets = ['searchInput', 'tabBandeja', 'tabListado', 'inputSearchPaciente'];
  static values = {
    url: String,
    urlDetalle: String
  }

  onClickDetails(e) {
    e.preventDefault();

    get(this.urlValue, {
      responseKind: 'turbo-stream'
    })
  }

  onClickPerformSearch(event) {
    event.preventDefault();

    get(this.urlValue, {
      responseKind: 'turbo-stream',
      query: {
        q: this.searchInputTarget.value || null
      }
    })
  }

  updateClass(e) {
    const bandejaTab = this.element.querySelector("#bandeja-tab")
    const listTab = this.element.querySelector("#list-tab")

    const bandejaContent = this.element.querySelector("#bandeja")
    const listContent = this.element.querySelector("#list")
    
    bandejaTab.classList.remove('active');
    listTab.classList.add('active');

    bandejaContent.classList.remove('show', 'active');
    listContent.classList.add('show', 'active');

    this.inputSearchPacienteTarget.value = ""
  }

  selectInternacion(e) { 
    e.preventDefault();
    const internacionId = e.currentTarget.dataset.autocompleteRegistroValue;
    const url = `${this.urlDetalleValue}/${internacionId}?laboratorio=true`;

    Turbo.visit(url, { frame: "pedido_details" });
  }
}
